import RoutesChangementMotDePasse from './changement-mot-de-passe/routes';
import RoutesEcranGestion from './gestion/routes';
import RoutesEcranGestionCompteEmployes from './gestion-employes/routes';
import RoutesModifierPersonnePhysique from './modification-personne-physique/routes';
import RoutesModifierResponsableLegal from './modification-responsable-legal/routes';
import RoutesAdressePrincipaleAdresse from './adresse-principale/routes';
import RoutesAjoutAdresseSecondaire from './ajouter-adresse-secondaire/routes';
import RoutesModificationAdresseSecondaire from './adresse-secondaire/routes';
import RoutesModifierInformationsCompte from './modifier-informations-compte/routes';
import RoutesModifierQuestionsReponses from './modifier-questions-reponses/routes';
import RoutesAjouterPersona from './ajouter-persona/routes';
import { initSubRoutes } from '../../../utils/router';
import RoutesAjouterEmploye from './ajouter-employe/routes';
import RoutesListeEmployes from './liste-employes/routes';
import RoutesModifierEmploye from './modifier-employe/routes';

const RoutesMonCompte = initSubRoutes({
    route: '/mon-compte',
    subroutes: {
        changementMotDePasse: RoutesChangementMotDePasse,
        ecranGestion: RoutesEcranGestion,
        ecranGestionCompteEmployes: RoutesEcranGestionCompteEmployes,
        modifierPersonnePhysique: RoutesModifierPersonnePhysique,
        modifierResponsableLegal: RoutesModifierResponsableLegal,
        adressePrincipale: RoutesAdressePrincipaleAdresse,
        ajouterAdresseSecondaire: RoutesAjoutAdresseSecondaire,
        modifierAdresseSecondaire: RoutesModificationAdresseSecondaire,
        modifierInformationsCompte: RoutesModifierInformationsCompte,
        modifierQuestionsReponses: RoutesModifierQuestionsReponses,
        ajouterPersona: RoutesAjouterPersona,
        ajouterEmploye: RoutesAjouterEmploye,
        modifierEmploye: RoutesModifierEmploye,
        listeEmployes: RoutesListeEmployes,
    },
    nom: 'Mon compte',
});

export default RoutesMonCompte;
